import classNames from "classnames";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import UpssAnimation from "assets/error.json";
import Lottie from "lottie-react";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

const NotFoundScreen: FC<Props> = ({
  title,
  text,
  size,
  buttonName,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.error}>
      <div className={styles.cat}>
        <Lottie
          className={classNames(
            styles.kittyCat,
            size === "small" ? styles.small : null,
            size === "medium" ? styles.medium : null
          )}
          animationData={UpssAnimation}
          loop={true}
        />
      </div>
      <div className={styles.titleWrapper}>
        <div className={styles.title}>
          {title ? title : <>{t("emptyStates.notFound")}</>}
        </div>
      </div>
      <div className={styles.body}>
        {text ? text : <>{t("errors.loadFileFailed")}</>}
      </div>
      {buttonName && (
        <div className={styles.buttons}>
          <Button text={buttonName} onClick={() => onClick?.()}></Button>
        </div>
      )}
    </div>
  );
};

export default NotFoundScreen;
